import styled, { css } from 'styled-components';
import { Border, Colors, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';
import { NAV_HEIGHT } from '../consts';

export const showFilterBarDesktopStyles = css`
  transform: translateY(0);
  opacity: 1;
  pointer-events: all;
`;

export const Container = styled.div<{
  animate: boolean;
  show?: boolean;
  isContentShowing?: boolean;
  isDockedOnDesktop?: boolean;
  isDockedOnTablet?: boolean;
  isDockedOnMobile?: boolean;
  smallMargin?: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${Spacing.HALF};
  padding: 0;
  ${({ animate = true, isContentShowing = false, show }) => css`
    transform: translateY(${show || isContentShowing ? '0' : '100%'});
    opacity: ${show || isContentShowing ? '1' : '0'};
    pointer-events: ${show || isContentShowing ? 'all' : 'none'};
    ${animate ? `transition: transform ${Transition.Time.BASE}, opacity ${Transition.Time.BASE};` : ''}
  `}

  & > button:first-child {
    margin-left: ${({ smallMargin }) => (smallMargin ? Spacing.HALF : Spacing.SINGLE)};
  }

  ${({ isContentShowing = false, show }) =>
    Mixins.Media.maxWidthMedium(`
    transform: translateY(0);
    padding: 0 ${Spacing.SINGLE};
    overflow-x: auto;
    overflow-y: overlay;
    -ms-overflow-style: none;
    scrollbar-width: none;
    ${show || isContentShowing ? `display: flex;` : `display: none;`}
  
    &::-webkit-scrollbar {
      -webkit-appearance: none;
      display: none;
    }
  `)}

  ${({ isDockedOnDesktop }) => Mixins.Media.minWidthLarge(isDockedOnDesktop ? showFilterBarDesktopStyles : '')}
  ${({ isDockedOnTablet }) => Mixins.Media.minWidthMedium(isDockedOnTablet ? 'display: flex;' : '')}
  ${({ isDockedOnMobile }) => Mixins.Media.minWidthSmall(isDockedOnMobile ? 'display: flex;' : '')}
`;

export const Inline = styled.div<{ navShowing?: boolean; navCanBeHiddenInline?: boolean; show?: boolean }>`
  display: flex;
  overflow: hidden;

  ${({ navCanBeHiddenInline, navShowing, show }) => css`
    border-left: ${Border.Base} ${navShowing && show ? Colors.GRAY_LITE_10 : 'transparent'};
    margin-left: ${navShowing || !navCanBeHiddenInline ? 0 : `-${Spacing.SINGLE_HALF}`};
  `};

  ${Mixins.Media.maxWidthMedium(`
    display: none;
  `)}

  &:empty {
    border-left: none;
    display: none;
    margin-left: 0;
  }
`;

export const Row = styled.div<{ hide?: boolean; isContentShowing?: boolean; isScrollingUp?: boolean }>`
  align-items: center;
  background: ${Colors.WHITE};
  border-bottom: ${Border.Base} ${Colors.GRAY_LITE_10};
  display: none;
  height: ${NAV_HEIGHT};
  z-index: 2;

  ${({ hide, isContentShowing, isScrollingUp }) => {
    const hideRow = hide || !isScrollingUp;
    const contentTransitionTime = isContentShowing ? '0s' : Transition.Time.BASE;
    return css`
      ${Mixins.Media.maxWidthMedium(`
        display: flex;
        overflow: hidden;
        transform: translateY(${hideRow && !isContentShowing ? `-${NAV_HEIGHT}` : '0px'});
        pointer-events: ${hideRow ? 'none' : 'all'};
        transition: transform ${contentTransitionTime}, height ${contentTransitionTime};

        &:empty {
          border-bottom: none;
          display: none;
        }
      `)}
      ${Mixins.Media.maxWidthSmall(`
        border-bottom-width: ${hideRow ? `0px` : `1px`};
        display: ${isContentShowing ? 'none' : 'flex'};
        overflow: hidden;
        transform: translateY(${hideRow ? `-${NAV_HEIGHT}` : '0px'});
        pointer-events: ${hideRow ? 'none' : 'all'};
        transition: transform ${contentTransitionTime}, height ${contentTransitionTime};

        &:empty {
          border-bottom: none;
          display: none;
        }
      `)}
    `;
  }}
`;
